import {Pipe, PipeTransform} from '@angular/core';
import {Age} from "../../generated-model/model";

@Pipe({
  name: 'age',
  standalone: true
})
export class AgePipe implements PipeTransform {

  transform(age: Age | undefined, ...args: unknown[]): unknown {
    if (!age) {
      return "-"
    }
    const ageYear = age.years ? `${age.years} ปี` : ''
    const ageMonth = age.years ? `${age.months} เดือน` : ''
    const ageDay = age.years ? `${age.days} วัน` : ''
    return `${ageYear} ${ageMonth} ${ageDay}`
  }

}
